import React from 'react';
import { Lock, ShieldAlert, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

/**
 * Componente reutilizável para exibir mensagem de acesso negado
 * Usado em páginas restritas para o perfil "secretaria"
 */
export default function AccessDeniedBlock({ 
  title = "Acesso Restrito", 
  message = "Você não tem permissão para acessar esta seção.",
  showBackButton = true,
  customIcon = null
}) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[60vh]" data-testid="access-denied-block">
      <div className="text-center p-8 bg-white dark:bg-slate-800 rounded-xl shadow-lg max-w-md border border-slate-200 dark:border-slate-700">
        <div className="w-20 h-20 mx-auto mb-6 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center">
          {customIcon || <ShieldAlert className="w-10 h-10 text-red-500" />}
        </div>
        
        <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-200 mb-3">
          {title}
        </h2>
        
        <p className="text-slate-600 dark:text-slate-400 mb-6">
          {message}
        </p>
        
        <div className="flex items-center justify-center gap-2 text-sm text-slate-500 dark:text-slate-400 mb-6">
          <Lock size={16} />
          <span>Seu perfil atual não possui acesso a este recurso</span>
        </div>
        
        {showBackButton && (
          <Button 
            onClick={() => navigate('/dashboard')} 
            className="bg-[#003366] hover:bg-[#002244]"
            data-testid="back-to-dashboard-btn"
          >
            <ArrowLeft size={16} className="mr-2" />
            Voltar ao Dashboard
          </Button>
        )}
      </div>
    </div>
  );
}
